"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "LookupGeneralHandler", {
    enumerable: true,
    get: function() {
        return LookupGeneralHandler;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _computed = require("../computed");
const _handlerUtils = require("~/db/field-handler/utils/handlerUtils");
const _models = require("~/models");
const _lookupHelpers = require("~/helpers/lookupHelpers");
const _conditionV2 = require("~/db/conditionV2");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
let LookupGeneralHandler = class LookupGeneralHandler extends _computed.ComputedFieldHandler {
    /**
   * Applies a filter condition for lookup columns based on the relation type.
   * It constructs a subquery to find related records that match the filter criteria
   * and then uses this subquery to filter the main query.
   *
   * @param knex - The Knex instance.
   * @param filter - The filter object containing comparison operator and value.
   * @param column - The lookup column being filtered.
   * @param options - Additional options including base model, alias count, error handling, and condition parser.
   * @returns A function that applies the filter condition to a query builder.
   */ async filter(knex, filter, column, options) {
        const { baseModel: baseModelSqlv2, depth: aliasCount, throwErrorIfInvalid, conditionParser: parseConditionV2 } = options;
        const context = baseModelSqlv2.context;
        let rootApply = undefined;
        const colOptions = await column.getColOptions(context);
        const relationColumn = await colOptions.getRelationColumn(context);
        const relationColumnOptions = await relationColumn.getColOptions(context);
        // const relationModel = await relationColumn.getModel();
        const { refContext, parentContext, childContext, mmContext } = await relationColumnOptions.getParentChildContext(context);
        const lookupColumn = await colOptions.getLookupColumn(refContext);
        const alias = (0, _handlerUtils.getAlias)(aliasCount);
        let qb;
        {
            const childColumn = await relationColumnOptions.getChildColumn(childContext);
            const parentColumn = await relationColumnOptions.getParentColumn(parentContext);
            const childModel = await childColumn.getModel(childContext);
            await childModel.getColumns(childContext);
            const parentModel = await parentColumn.getModel(parentContext);
            await parentModel.getColumns(parentContext);
            const childBaseModel = await _models.Model.getBaseModelSQL(childContext, {
                model: childModel,
                dbDriver: baseModelSqlv2.dbDriver
            });
            const parentBaseModel = await _models.Model.getBaseModelSQL(parentContext, {
                model: parentModel,
                dbDriver: baseModelSqlv2.dbDriver
            });
            let relationType = relationColumnOptions.type;
            if (relationType === _nocodbsdk.RelationTypes.ONE_TO_ONE) {
                var _relationColumn_meta;
                relationType = ((_relationColumn_meta = relationColumn.meta) == null ? void 0 : _relationColumn_meta.bt) ? _nocodbsdk.RelationTypes.BELONGS_TO : _nocodbsdk.RelationTypes.HAS_MANY;
            }
            if (relationType === _nocodbsdk.RelationTypes.HAS_MANY) {
                var _parseProp;
                const useRecursiveEvaluation = (_parseProp = (0, _nocodbsdk.parseProp)(column.meta)) == null ? void 0 : _parseProp.useRecursiveEvaluation;
                // TODO: [recursive lookup]
                // eslint-disable-next-line no-constant-condition
                if (false && useRecursiveEvaluation) {
                    rootApply = await (0, _lookupHelpers.recursiveCTEFromLookupColumn)({
                        baseModelSqlV2: childBaseModel,
                        lookupColumn: column,
                        tableAlias: alias
                    });
                    qb = knex(knex.raw(`?? as ??`, [
                        alias,
                        alias
                    ])).where(`${alias}.root_id`, '<>', knex.raw('??.??', [
                        alias,
                        'id'
                    ]));
                    qb.distinct().select(`${alias}.root_id`);
                } else {
                    qb = knex(knex.raw(`?? as ??`, [
                        childBaseModel.getTnPath(childModel.table_name),
                        alias
                    ]));
                    qb.select(`${alias}.${childColumn.column_name}`);
                    qb.whereNotNull(`${alias}.${childColumn.column_name}`);
                }
                const conditionJoinResult = await (0, _handlerUtils.nestedConditionJoin)({
                    baseModelSqlv2: childBaseModel,
                    filter: _extends({}, filter, filter.comparison_op in _handlerUtils.negatedMapping ? _handlerUtils.negatedMapping[filter.comparison_op] : {}),
                    lookupColumn,
                    knex,
                    alias,
                    aliasCount,
                    throwErrorIfInvalid,
                    parseConditionV2
                });
                conditionJoinResult.clause(qb);
                await (0, _conditionV2.extractLinkRelFiltersAndApply)({
                    context,
                    column: column,
                    table: childBaseModel.model,
                    baseModel: childBaseModel,
                    qb,
                    alias
                });
                return {
                    rootApply: (qb)=>{
                        rootApply == null ? void 0 : rootApply(qb);
                        conditionJoinResult.rootApply == null ? void 0 : conditionJoinResult.rootApply.call(conditionJoinResult, qb);
                    },
                    clause: (qbP)=>{
                        if (filter.comparison_op in _handlerUtils.negatedMapping) qbP.whereNotIn(parentColumn.column_name, qb);
                        else qbP.whereIn(parentColumn.column_name, qb);
                    }
                };
            } else if (relationType === _nocodbsdk.RelationTypes.BELONGS_TO) {
                var _parseProp1;
                let comparisonColumnName = childColumn.column_name;
                const useRecursiveEvaluation = (_parseProp1 = (0, _nocodbsdk.parseProp)(column.meta)) == null ? void 0 : _parseProp1.useRecursiveEvaluation;
                // TODO: [recursive lookup]
                // eslint-disable-next-line no-constant-condition
                if (false && useRecursiveEvaluation) {
                    comparisonColumnName = parentColumn.column_name;
                    rootApply = await (0, _lookupHelpers.recursiveCTEFromLookupColumn)({
                        baseModelSqlV2: childBaseModel,
                        lookupColumn: column,
                        tableAlias: alias
                    });
                    qb = knex(knex.raw(`?? as ??`, [
                        alias,
                        alias
                    ])).where(`${alias}.root_id`, '<>', knex.raw('??.??', [
                        alias,
                        'id'
                    ]));
                    qb.distinct().select(`${alias}.root_id`);
                } else {
                    qb = knex(knex.raw(`?? as ??`, [
                        parentBaseModel.getTnPath(parentModel.table_name),
                        alias
                    ]));
                    qb.select(`${alias}.${parentColumn.column_name}`);
                    qb.whereNotNull(`${alias}.${parentColumn.column_name}`);
                }
                const conditionJoinResult = await (0, _handlerUtils.nestedConditionJoin)({
                    baseModelSqlv2: parentBaseModel,
                    filter: _extends({}, filter, filter.comparison_op in _handlerUtils.negatedMapping ? _handlerUtils.negatedMapping[filter.comparison_op] : {}),
                    lookupColumn,
                    knex,
                    alias,
                    aliasCount,
                    throwErrorIfInvalid,
                    parseConditionV2
                });
                conditionJoinResult.clause(qb);
                await (0, _conditionV2.extractLinkRelFiltersAndApply)({
                    context,
                    column: column,
                    table: parentBaseModel.model,
                    baseModel: parentBaseModel,
                    qb,
                    alias
                });
                return {
                    rootApply: (qb)=>{
                        rootApply == null ? void 0 : rootApply(qb);
                        conditionJoinResult.rootApply == null ? void 0 : conditionJoinResult.rootApply.call(conditionJoinResult, qb);
                    },
                    clause: (qbP)=>{
                        if (filter.comparison_op in _handlerUtils.negatedMapping) qbP.where((qb1)=>qb1.whereNotIn(comparisonColumnName, qb).orWhereNull(childColumn.column_name));
                        else qbP.whereIn(comparisonColumnName, qb);
                    }
                };
            } else if (relationType === _nocodbsdk.RelationTypes.MANY_TO_MANY) {
                const mmModel = await relationColumnOptions.getMMModel(mmContext);
                const mmParentColumn = await relationColumnOptions.getMMParentColumn(mmContext);
                const mmChildColumn = await relationColumnOptions.getMMChildColumn(mmContext);
                const mmBaseModel = await _models.Model.getBaseModelSQL(mmContext, {
                    model: mmModel,
                    dbDriver: baseModelSqlv2.dbDriver
                });
                const childAlias = `__nc${aliasCount.count++}`;
                qb = knex(knex.raw(`?? as ??`, [
                    mmBaseModel.getTnPath(mmModel.table_name),
                    alias
                ])).select(`${alias}.${mmChildColumn.column_name}`).whereNotNull(`${alias}.${mmChildColumn.column_name}`).join(knex.raw(`?? as ??`, [
                    parentBaseModel.getTnPath(parentModel.table_name),
                    childAlias
                ]), `${alias}.${mmParentColumn.column_name}`, `${childAlias}.${parentColumn.column_name}`);
                const conditionJoinResult = await (0, _handlerUtils.nestedConditionJoin)({
                    baseModelSqlv2: parentBaseModel,
                    filter: _extends({}, filter, filter.comparison_op in _handlerUtils.negatedMapping ? _handlerUtils.negatedMapping[filter.comparison_op] : {}),
                    lookupColumn,
                    knex,
                    alias: childAlias,
                    aliasCount,
                    throwErrorIfInvalid,
                    parseConditionV2
                });
                conditionJoinResult.clause(qb);
                await (0, _conditionV2.extractLinkRelFiltersAndApply)({
                    context,
                    column: column,
                    table: childBaseModel.model,
                    baseModel: childBaseModel,
                    qb,
                    alias
                });
                return {
                    rootApply: (qb)=>{
                        rootApply == null ? void 0 : rootApply(qb);
                        conditionJoinResult.rootApply == null ? void 0 : conditionJoinResult.rootApply.call(conditionJoinResult, qb);
                    },
                    clause: (qbP)=>{
                        if (filter.comparison_op in _handlerUtils.negatedMapping) qbP.where((qb1)=>qb1.whereNotIn(childColumn.column_name, qb).orWhereNull(childColumn.column_name));
                        else qbP.whereIn(childColumn.column_name, qb);
                    }
                };
            }
        }
    }
    async parseDbValue(params) {
        // const lookupNestedCol = await params.baseModel.getNestedColumn(
        //   params.column,
        // );
        // if (lookupNestedCol) {
        //   return await params.options.fieldHandler.parseDbValue({
        //     ...params,
        //     value:
        //       params.row[lookupNestedCol.id] ??
        //       params.row[lookupNestedCol.column_name] ??
        //       params.row[lookupNestedCol.title],
        //     column: lookupNestedCol,
        //   });
        // }
        return {
            value: params.value
        };
    }
};
